/*
  Cart drawer conversion nudges for Kultra.

  Handles the "Add another bag" button inside the cart drawer: it adds the item
  to the cart over AJAX and refreshes the drawer in place — it never navigates
  to the cart page. Also keeps the nudge block fresh when the cart is changed
  by another script (e.g. a subscription app) that only partially re-renders.

  Display logic (progress %, remaining amount, offer state) is all server-side
  Liquid in snippets/cart-drawer.liquid.
*/
(function () {
  var ADD_SELECTOR = '[data-cart-nudge-add]';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /*
    Promo scoping.

    The sticky bar's code is a CART-LEVEL discount: once registered it
    discounts every eligible line, including bags added from the purchase
    options, which reads as the promo leaking. Shopify cannot scope a code to
    a single line, so instead it is cleared on every add that did not come
    from the sticky bar.

    POST /cart/update.js with an empty discount is what clears it. Verified
    against the live cart: 200, discount_codes emptied, total restored.

    Quantity changes are deliberately NOT cleared, so a shopper who used the
    sticky bar and then edits quantity keeps their promo.
  */
  var keepPromoOnce = false;

  // Called by the sticky bar immediately before its own add.
  window.kultraKeepPromoOnce = function () {
    keepPromoOnce = true;
  };

  function clearPromo() {
    if (keepPromoOnce) {
      keepPromoOnce = false;
      return Promise.resolve();
    }
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' }),
    }).catch(function () {});
  }

  function swapById(id, html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + id);
    var current = document.getElementById(id);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function reopenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    var overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (typeof drawer.open === 'function') drawer.open();
  }

  function addAnother(button) {
    if (button.classList.contains('is-loading')) return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var qty = parseInt(button.getAttribute("data-quantity"), 10);
    var payload = { id: variantId, quantity: qty > 0 ? qty : 1 };
    var sellingPlan = button.getAttribute('data-selling-plan');
    if (sellingPlan) payload.selling_plan = sellingPlan;

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    // Form-encoded, not JSON. Shopify silently ignores selling_plan on a JSON
    // body (verified live: 200 OK, line comes back as a one-off at full
    // price), and only honours it form-encoded. Everything else works either
    // way, so form-encoded is simply the safe choice.
    var encoded = Object.keys(payload)
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]); })
      .join('&');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: encoded,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add.js ' + res.status);
        // Before re-rendering, so the drawer never shows a promo this add
        // was not entitled to.
        return clearPromo();
      })
      .then(function () {
        return Promise.all([
          fetch(root() + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
          fetch(root() + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).catch(function () { return null; }),
        ]);
      })
      .then(function (parts) {
        swapById('CartDrawer', parts[0]);
        swapById('cart-icon-bubble', parts[1]);
        reopenDrawer();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
        }
      })
      .catch(function (e) {
        console.error('[cart-nudge] add failed', e);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(ADD_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    addAnother(button);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    var HANDLED = ['cart-drawer-upsell', 'product-form', 'cart-items'];
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      // The theme's own add-to-cart. It never registers the promo, so any
      // code still on the cart came from an earlier sticky-bar click and
      // must not carry over to this purchase.
      if (payload && payload.source === 'product-form') {
        clearPromo().then(function () {
          return fetch(root() + '?section_id=cart-drawer').then(function (r) { return r.text(); });
        }).then(function (text) {
          swapById('CartDrawer', text);
        }).catch(function () {});
        return;
      }
      if (payload && HANDLED.indexOf(payload.source) !== -1) return;
      if (!document.querySelector('[data-cart-nudge]')) return;
      fetch(root() + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var freshNudge = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-cart-nudge]');
          var currentNudge = document.querySelector('[data-cart-nudge]');
          if (freshNudge && currentNudge) currentNudge.replaceWith(freshNudge);
        })
        .catch(function () {});
    });
  }
})();